module.exports = __webpack_public_path__ + "images/FUSA_icons/051-24-hours-1.d342eab6f69dce8fdf3ea2ca59618860.svg";